module.exports = __webpack_public_path__ + "img/Bear07.4b6f022d.jpg";